<template>
  <div class="overlay">
    <div class="container" v-if="$store.state.isMobile">
      <input
        id="toggle"
        type="checkbox"
        v-model="navOpen"
        aria-label="Navigation"
      />

      <!-- IMPORTANT: Any element that we want to modify when the checkbox state changes go here, being "sibling" of the checkbox element -->

      <!-- This label is tied to the checkbox, and it will contain the toggle "buttons" -->
      <label class="toggle-container" for="toggle">
        <!-- If menu is open, it will be the "X" icon, otherwise just a clickable area behind the hamburger menu icon -->
        <span class="button button-toggle"></span>
      </label>

      <!-- The nav menu -->
      <nav class="nav">
        <router-link to="/" @click.native="navOpen = false" class="nav-item"
          >Home</router-link
        >
        <router-link
          to="/#Projects"
          @click.native="scrollFix('#Projects')"
          class="nav-item"
          >Projects</router-link
        >
        <router-link
          to="/#About"
          @click.native="scrollFix('#About')"
          class="nav-item"
          >About</router-link
        >
      </nav>
    </div>
    <nav class="row" v-else>
      <router-link to="/" class="col-xs-3 col-sm-4 col-md-2 frame">
        <h1>Robbey Orth</h1>
      </router-link>
      <router-link
        to="/#Projects"
        @click.native="scrollFix('#Projects')"
        class="col-sm-offset-1 col-md-offset-5 col-sm-2 col-md-1 frame"
      >
        <h1>Projects</h1>
      </router-link>
      <router-link
        to="/#About"
        @click.native="scrollFix('#About')"
        class="col-sm-1 col-md-1 frame"
      >
        <h1>About</h1>
      </router-link>
    </nav>
    <div class="row bottom">
      <h1 class="col-sm-offset-4 bottom">
        Copyright &copy;{{ copyrightYear }} Robbey Orth
      </h1>
    </div>
  </div>
</template>

<script>
const TIMEOUT = 1;
export default {
  name: "OverlayNav",
  data() {
    return {
      navOpen: false
    };
  },
  mounted() {
    // From testing, without a brief timeout, it won't work.
    if (this.$route.hash) {
      setTimeout(() => this.scrollFix(this.$route.hash), TIMEOUT);
    }
  },
  methods: {
    scrollFix: function(hashtag) {
      this.navOpen = false;
      setTimeout(() => {
        if (location.href.includes("/Project")) {
          window.scrollTo({
            top: document.querySelector(hashtag).offsetTop,
            behavior: "auto"
          });
        } else {
          window.scrollTo({
            top: document.querySelector(hashtag).offsetTop,
            behavior: "smooth"
          });
        }
      }, TIMEOUT);
    }
  },
  computed: {
    copyrightYear: function() {
      return new Date().getFullYear();
    }
  }
};
</script>

<style scoped lang="scss">
.overlay {
  font-size: 0.5rem;
  white-space: nowrap;
  position: fixed;
  z-index: 999;
  width: 100%;
  // margin: 0;
  // min-height: 100vh;
  .bottom {
    position: fixed;
    bottom: $gutter;
    // right: 19.875rem;
  }
  .frame {
    padding-top: $gutter;
  }
  .bottom,
  .frame {
    h1 {
      // position: fixed;
      font-family: $text-font-stack;
      letter-spacing: 0.2rem;
      font-weight: 500;
      text-align: left;
      text-transform: uppercase;
      color: #a1a1a1;
      text-decoration: none;
    }
  }
  a:hover,
  h1:hover {
    color: $brand-blue;
    text-decoration: none;
  }
  a:visited {
    text-decoration: none;
  }
  a:active {
    text-decoration: none;
  }
}

a.router-link-exact-active,
a.router-link-active {
  text-decoration: none;
}

/*
 Hamburger Menu
 */

$items: 4;
$transition-duration: 0.5s;
$transition-delay: 0.05s;

.container {
  position: relative;
  // margin-right: $gutter;
  // margin: 0 auto;
  // width: 100%;
  // height: 534px;
  // background-color: $dark-grey;
  overflow: hidden;
  z-index: 999;
}

/* Toggle functionality */

// To hide the checkbox
#toggle {
  position: absolute;
  right: -100%;
  top: -100%;
}

#toggle {
  & ~ .toggle-container .button-toggle {
    box-shadow: 0 0 0 8px rgba($brand-blue, 0.1),
      inset 0 0 0 20px rgba($brand-blue, 0.1);
  }
}

// Styles for the 'open' state, if the checkbox is checked
#toggle:checked {
  // Any element you need to change the style if menu is open goes here, using the sibling selector (~) as follows

  // Making the "X" icon using `:before` and `:after` pseudo-elements
  & ~ .toggle-container .button-toggle {
    box-shadow: 0 0 0 550px rgba($dark-grey, 0.5),
      inset 0 0 0 20px rgba($dark-grey, 0.5);

    &:hover {
      box-shadow: 0 0 0 550px rgba($dark-grey, 0.5),
        inset 0 0 0 20px rgba($dark-grey, 0.5), 0 0 0 8px rgba($dark-grey, 0.1),
        inset 0 0 0 20px rgba($dark-grey, 0.1);
    }

    &:before {
      transform: translateY(-50%) rotate(45deg) scale(1);
    }

    &:after {
      transform: translateY(-50%) rotate(-45deg) scale(1);
    }
  }

  &:focus ~ .toggle-container .button-toggle {
    box-shadow: 0 0 0 550px rgba($brand-blue, 0.5),
      inset 0 0 0 20px rgba($brand-blue, 0.5), 0 0 0 8px rgba($brand-blue, 0.1),
      inset 0 0 0 20px rgba($brand-blue, 0.1);
  }

  // Open nav
  & ~ .nav {
    margin-bottom: 100px;
    pointer-events: auto;
    transform: translate(-50px, 50px);
    // margin-right: $gutter;

    // Restoring nav items from "lines" in the menu icon
    .nav-item {
      color: $back-white;
      letter-spacing: 0;
      height: 40px;
      line-height: 40px;
      margin-top: 0;
      opacity: 1;
      transform: scaleY(1);
      transition: $transition-duration, opacity 0.1s;
      font-weight: 500;
      font-size: 1rem;

      // Setting delays for the nav items in open transition
      @for $i from 1 through $items {
        &:nth-child(#{$i}) {
          $delay: ($items - $i) * $transition-delay;
          transition-delay: $delay;
          &:before {
            transition-delay: $delay;
          }
        }
      }

      // Hiding the lines
      &:before {
        opacity: 0;
      }
    }
  }

  // Dummy content
  & ~ .dummy-content {
    padding-top: 30px;

    &:before {
      background-color: rgba(0, 0, 0, 0.3);
    }
  }
}

/* Toggle button */

.button-toggle {
  position: absolute;
  display: inline-block;
  width: 20px;
  height: 20px;
  margin: 25px;
  float: right;
  background-color: transparent;
  border: none;
  right: $gutter;
  cursor: pointer;
  border-radius: 100%;
  transition: $transition-duration + 0.1;

  // Shadow on hover
  &:hover {
    box-shadow: 0 0 0 8px rgba(0, 0, 0, 0.1),
      inset 0 0 0 20px rgba(0, 0, 0, 0.1);
  }

  // Making the "X" icon using `:before` and `:after` pseudo-elements
  // Initially hidden because `scale(0)` transformation

  &:before,
  &:after {
    position: absolute;
    content: "";
    top: 50%;
    right: 0;
    width: 100%;
    height: 2px;
    background-color: $off-white;
    border-radius: 5px;
    transition: $transition-duration;
  }

  &:before {
    transform: translateY(-50%) rotate(45deg) scale(0);
  }

  &:after {
    transform: translateY(-50%) rotate(-45deg) scale(0);
  }
}

/* Menu */

.nav {
  display: inline-block;
  margin-top: 25px;
  margin-bottom: 20px;
  margin-right: 25px;
  // margin: 25px 25px 25px;
  float: right;
  // right: $gutter;
  // Don't want pointer-events as menu is closed
  pointer-events: none;
  transition: $transition-duration;
}

// Showing nav items as lines, making up the hamburger menu icon
.nav-item {
  position: relative;
  display: inline-block;
  float: right;
  clear: both;
  color: transparent;
  font-size: 14px;
  letter-spacing: -6.2px;
  height: 7px;
  line-height: 7px;
  text-transform: uppercase;
  white-space: nowrap;
  transform: scaleY(0.2);
  transition: $transition-duration, opacity 1s;

  // Setting delays for the nav items in close transition
  @for $i from 1 through $items {
    &:nth-child(#{$i}) {
      $delay: ($i - 1) * $transition-delay;
      transition-delay: $delay;
      &:before {
        transition-delay: $delay;
      }
    }
  }

  // Adjusting width for the first line
  &:nth-child(1) {
    letter-spacing: -8px;
  }

  // Adjusting width for the second line
  &:nth-child(2) {
    letter-spacing: -7px;
  }

  // Adjusting from the fourth element onwards
  &:nth-child(n + 4) {
    letter-spacing: -8px;
    margin-top: -7px;
    opacity: 0;
  }

  // Getting the lines for the hamburger menu icon
  &:before {
    position: absolute;
    content: "";
    top: 50%;
    right: 0;
    width: 100%;
    height: 2px;
    background-color: $mid-grey;
    transform: translateY(-50%) scaleY(5);
    transition: $transition-duration;
  }
}
</style>
